<template>
  <dp-container
    :fluid="false"
    :container="{
      cols: 12,
      sm: 12,
      md: 8,
      offsetMd: 2,
      lg: 6,
      offsetLg: 3,
      xl: 6,
      offsetXl: 3,
    }"
    col-class="panel-wrapper px-4 py-4"
  >
    <section class="mb-3">
      <b-link :to="{ name: redirectPath, params: redirectParams }" class="text-decoration-none" v-text="$t('productConfigBackLink.Back')" />
    </section>
    <dp-loading v-show="loading" />
    <dp-add-a-pet-form
      v-show="!loading"
      ref="form"
      :all-breeds="{ catBreeds: breedsCat, dogBreeds: breedsDog }"
      :existing-pet-names="getAllActivePetNames"
      :inactive-pet-names="getAllInactivePetNames"
      :duplicate-pet-name="duplicatePetName"
      :duplicate-pet-message="getError"
      :customer-support-phone="customerSupportPhone"
      continue-button-label="Save and Add Photo"
      @addPet="addPetAndAssign"
    />
  </dp-container>
</template>

<script>
import { DpAddAPetForm, DpContainer, DpLoading } from '@docupet/component-library';
import { mapGetters, mapState, mapActions } from 'vuex';

export default {
  name: 'AddPet',
  components: {
    DpLoading,
    DpContainer,
    DpAddAPetForm,
  },
  props: {
    autoAssignBackProductId: {
      type: [String, Number],
      default: null,
      required: false,
    },
    redirectPath: {
      type: String,
      default: 'AssignProduct',
      required: false,
    },
    redirectParams: {
      type: Object,
      default: () => ({}),
      required: false,
    },
    redirectPetIdParam: {
      type: String,
      default: null,
      required: false,
    },
  },
  data() {
    return {
      loading: false,
      duplicatePetName: '',
    };
  },
  computed: {
    ...mapState('pets', ['breedsCat', 'breedsDog']),
    ...mapGetters('pets', ['getAllActivePetNames', 'getAllInactivePetNames', 'getError']),
    ...mapState('user', ['user']),
    customerSupportPhone() {
      return this.user.city?.branding?.customerSupportPhone || '';
    },
  },
  beforeRouteEnter(to, from, next) {
    if (window.matchMedia('(min-width: 768px)').matches) document.body.style.backgroundColor = '#f6f6f6';
    next();
  },
  beforeRouteLeave(to, from, next) {
    next();
  },
  created() {
    this.$store.dispatch('pets/fetchPets');
    this.$store.dispatch('pets/fetchBreeds');
  },
  mounted() {
    this.clearErrors();
  },
  methods: {
    ...mapActions('pets', ['clearErrors']),
    async addPetAndAssign({ type, isIndoor, name, breed, gender, birthday, dobIsApproximate, colors }) {
      try {
        this.loading = true;

        await this.clearErrors();

        this.duplicatePetName = name;

        const pet = await this.$store.dispatch('pets/addPet', {
          vm: this,
          payload: { type, isIndoor, name, breed, gender, birthday, dobIsApproximate, colors },
        });

        if (!pet) {
          return;
        }

        this.duplicatePetName = '';

        const redirect = this.$router.resolve({
          name: 'AssignProduct',
          autoAssignProduct: {
            productId: `${this.autoAssignBackProductId}`,
            petId: `${pet?.id}`,
          },
          ...this.redirectParams,
          ...(this.redirectPetIdParam ? { [this.redirectPetIdParam]: pet?.id || null } : {}),
        }).href;

        return await this.$router.push({
          name: 'AddPetImage',
          params: {
            uuid: pet.uuid,
          },
          query: {
            redirect: redirect,
          },
        });
      } catch (e) {
        if (['address_with_same_pet', 'account_with_same_pet'].includes(e?.code)) {
          this.$refs.form?.$refs.form.setErrors({
            'pet-name': e.message,
          });
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
